// extracted by mini-css-extract-plugin
export default {"topPanel":"topPanel__ActivityViewerInterstitial__uEDnx","main":"main__ActivityViewerInterstitial__uEDnx"};